import { Copy } from "./copy/copy";
import { Info } from "./info/info";
import { Table } from "./table/table";

export const Widget = () => <></>;

Widget.Info = Info;
Widget.Copy = Copy;
Widget.Table = Table;
